import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllSubjects({ payload }) {
  try {
    yield put(actions.addSubjectLoading(true));
    const result = yield call(api.getAllSubjects);
    yield put(actions.getSystemSubjectsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getSystemSubjectsFail());
  } finally {
    yield put(actions.addSubjectLoading(false));
  }
}

//Edit Tables

export default function* SystemSubjectSaga() {
  yield takeLatest(Types.GET_SYSTEM_SUBJECTS_REQUEST, getAllSubjects);
}
